const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "18%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "7%"
  },
  {
    key: "avgOutRate",
    zh: "平均频率(Hz)",
    en: "Average Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "upperRateLimit",
    zh: "上限频率(Hz)",
    en: "Upper Limit Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "lowerRateLimit",
    zh: "下限频率(Hz)",
    en: "Lower Limit Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "settingPressure",
    zh: "设定压力(Mpa)",
    en: "Rated Pressure(Mpa)",
    width: "10%",
    tooltip: true
  },
  {
    key: "avgPressure",
    zh: "平均压力(Mpa)",
    en: "Average Pressure(Mpa)",
    width: "10%",
    tooltip: true
  },
  {
    key: "avgTemperature",
    zh: "平均温度(℃)",
    en: "Average Temperature(℃)",
    width: "11%",
    tooltip: true
  }
]

export default columns